import { render } from "./Upgrader.vue?vue&type=template&id=4b620ddd&scoped=true"
import script from "./Upgrader.vue?vue&type=script&lang=js"
export * from "./Upgrader.vue?vue&type=script&lang=js"

import "./Upgrader.vue?vue&type=style&index=0&id=4b620ddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b620ddd"]])

export default __exports__